// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generatePayslip-container {
  padding: 20px;
  max-width: 1100px;
  margin: 0 auto;
  border-radius: 8px;
  max-height: 400px;
}

.generatePayslip-header {
  display: flex;
  justify-content: flex-end; /* Align button to the right */
  align-items: center;
  margin-bottom: 20px;
  padding: 10px 20px;
  border-radius: 8px;
}
.generatePayslip-heading {
  font-size: 1.75rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.generatePayslip-create-btn {
  padding: 12px 24px;
  background-color: #7FBD2C;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.generatePayslip-create-btn:hover {
  background-color: #6aa824;
  transform: translateY(-1px);
}

.generatePayslip-create-btn:active {
  transform: translateY(0);
}

.generatePayslip-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.generatePayslip-save-only-btn {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
}

.generatePayslip-save-only-btn:hover {
  background-color: #0056b3;
}

.generatePayslip-save-only-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.generatePayslip-error {
  color: red;
  font-size: 14px;
  margin: 10px 0;
  text-align: center;
}

.generatePayslip-success {
  color: green;
  font-size: 14px;
  margin: 10px 0;
  text-align: center;
}
.generatePayslip-required {
  color: red;
  margin-left: 4px;
}
.generatePayslip-table-container {
  max-height: 600px;
  overflow-y: auto;
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* .generatePayslip-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: auto;
  border: 1px solid #e0e0e0; /* Add border to table */
 

/* .generatePayslip-table-header {
  position: sticky;
  top: 0;
  background-color: #f4f4f4;
  padding: 12px;
  text-align: left;
  border-bottom: 2px solid #ddd;
  font-weight: bold;
  z-index: 1;
} */

.generatePayslip-table td {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

.generatePayslip-table tr:hover {
  background-color: #f9f9f9;
}

.generatePayslip-edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #007bff;
}

.generatePayslip-edit-btn:hover {
  color: #0056b3;
}
.generatePayslip-form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.generatePayslip-popup-box {
  margin-top:70px;
  position: relative;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  width: 900px;
  max-width: 90%;
  max-height: 70vh;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
}

.generatePayslip-popup-title {
  background-color: #00468C;
  color: white;
  padding: 15px;
  margin: -20px -20px 20px -20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.generatePayslip-popup-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: #ffffff;
  color: #00468C;
  border: 2px solid #00468C;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.1s ease;
}

.generatePayslip-popup-close-btn:hover {
  background-color: #00468C;
  color: white;
  transform: scale(1.1);
}

.generatePayslip-popup-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.generatePayslip-form-row {
  display: flex;
  gap: 20px;
  flex-wrap: nowrap;
}

.generatePayslip-form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  min-width: 0;
}

.generatePayslip-form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
}

.generatePayslip-popup-input {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.generatePayslip-popup-input:focus {
  border-color: #00468C;
  outline: none;
}

.generatePayslip-form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 20px;
}

.generatePayslip-cancel-btn,
.generatePayslip-save-btn,
.generatePayslip-preview-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.generatePayslip-cancel-btn {
  background-color: #e0e0e0;
  color: #333;
}

.generatePayslip-cancel-btn:hover {
  background-color: #d0d0d0;
}

.generatePayslip-save-btn,
.generatePayslip-preview-btn {
  background-color: #00468C;
  color: white;
}

.generatePayslip-save-btn:hover,
.generatePayslip-preview-btn:hover {
  background-color: #003a6e;
}

.generatePayslip-preview {
  font-size: 14px;
  color: #333;
}

.generatePayslip-preview-header {
  text-align: left;
  margin-bottom: 20px;
}

.generatePayslip-preview-header h4 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 5px;
}

.generatePayslip-preview-header p {
  font-size: 12px;
  margin: 2px 0;
}

.generatePayslip-preview-header h5 {
  font-size: 14px;
  font-weight: 600;
  margin: 10px 0 5px;
}

.generatePayslip-preview-table {
  width: 100%;

  border-collapse: collapse;
  margin-bottom: 15px;
}

.generatePayslip-preview-table th,
.generatePayslip-preview-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  font-size: 12px;
}

.generatePayslip-preview-table th {
  background-color: #00468C;
  color: white;
  font-weight: 600;
}

.generatePayslip-preview-table.earnings-deductions th,
.generatePayslip-preview-table.earnings-deductions td {
  width: 25%;
}

.generatePayslip-preview p {
  font-size: 12px;
  margin: 5px 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .generatePayslip-header {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .generatePayslip-create-btn {
    width: 100%;
    text-align: center;
  }

  .generatePayslip-popup-box {
    width: 90%;
    padding: 15px;
  }

  .generatePayslip-popup-title {
    font-size: 18px;
    padding: 12px;
  }

  .generatePayslip-form-row {
    flex-direction: column;
    gap: 1rem;
  }

  .generatePayslip-form-group {
    width: 100%;
  }

  .generatePayslip-preview-table.earnings-deductions th,
  .generatePayslip-preview-table.earnings-deductions td {
    width: auto;
  }
}
.generatePayslip-table-container {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
  margin-top: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.generatePayslip-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: auto;
}

.generatePayslip-table-header {
  position: sticky;
  
  top: 0;
  background-color: #f8f9fa;
  padding: 12px 8px;
  text-align: left;
  border-bottom: 2px solid #dee2e6;
  border-right: 1px solid #dee2e6; /* Add vertical lines */
  font-weight: 800;
  color: #333;
  /* text-transform: uppercase; */
  font-size: 12px;
  white-space: nowrap;
}

.generatePayslip-table-cell {
  padding: 10px 8px;
  border-bottom: 1px solid #e9ecef;
  border-right: 1px solid #e9ecef; /* Add vertical lines */
  text-align: left;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Search bar container */
.generatePayslip-search-container {
  display: flex;
  align-items: center;
  position: relative; /* For positioning the search icon */
  max-width: 270px;
  margin-left:-20px;
}

/* Search input */
.generatePayslip-search-input {
  padding: 10px 36px 10px 10px; /* Add padding-right for icon, reduce padding-left */
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
}

.generatePayslip-search-input:focus {
  border-color: #00468C;
  outline: none;
}

/* Search icon */
.generatePayslip-search-icon {
  position: absolute;
  right: 10px; /* Move icon to the right */
  top: 50%;
  transform: translateY(-50%);
  color: #8f8c8c; /* Black color for search icon */
  font-size: 16px;
}

/* Ensure header layout */
.generatePayslip-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 10px 20px;
  border-radius: 8px;
}

/* Rest of your existing CSS remains unchanged */
/* Edit button with boxed pencil icon */
.generatePayslip-edit-btn {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 6px;
  cursor: pointer;
  font-size: 16px;
  color: #000000; /* Black pencil icon */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.generatePayslip-edit-btn:hover {
  background: #e9ecef;
  color: #555555;
}
/* Last column without right border to avoid double lines */
.generatePayslip-table-cell:last-child,
.generatePayslip-table-header:last-child {
  border-right: none;
}
/* Specific column widths to minimize horizontal scrolling */
.generatePayslip-table-cell:nth-child(1) { /* Employee Name */
  max-width: 120px;
}
.generatePayslip-table-cell:nth-child(2) { /* Employee ID */
  max-width: 100px;
}
.generatePayslip-table-cell:nth-child(3) { /* Gender */
  max-width: 80px;
}
.generatePayslip-table-cell:nth-child(4) { /* Designation */
  max-width: 100px;
}
.generatePayslip-table-cell:nth-child(5) { /* Date of Joining */
  max-width: 100px;
}
.generatePayslip-table-cell:nth-child(6) { /* Account No */
  max-width: 100px;
}
.generatePayslip-table-cell:nth-child(7), /* Working Days */
.generatePayslip-table-cell:nth-child(8) { /* Leaves Taken */
  max-width: 80px;
}
.generatePayslip-table-cell:nth-child(9), /* UIN No */
.generatePayslip-table-cell:nth-child(10), /* PAN Number */
.generatePayslip-table-cell:nth-child(11), /* ESI Number */
.generatePayslip-table-cell:nth-child(12) { /* PF Number */
  max-width: 100px;
}
.generatePayslip-table-cell:nth-child(13), /* Basic */
.generatePayslip-table-cell:nth-child(14), /* HRA */
.generatePayslip-table-cell:nth-child(15), /* Other Allowance */
.generatePayslip-table-cell:nth-child(16), /* PF */
.generatePayslip-table-cell:nth-child(17), /* ESI/Insurance */
.generatePayslip-table-cell:nth-child(18), /* Professional Tax */
.generatePayslip-table-cell:nth-child(19), /* TDS */
.generatePayslip-table-cell:nth-child(20), /* Gross Earnings */
.generatePayslip-table-cell:nth-child(21), /* Total Deductions */
.generatePayslip-table-cell:nth-child(22) { /* Net Salary */
  max-width: 90px;
}
.generatePayslip-table-cell:nth-child(23) { /* Created At */
  max-width: 120px;
}
.generatePayslip-table-cell:nth-child(24) { /* Edit Data */
  max-width: 60px;
  text-align: center;
}

.generatePayslip-table tr:hover {
  background-color: #f1f3f5;
}

.generatePayslip-edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #000000; /* Black pencil icon */
}

.generatePayslip-edit-btn:hover {
  color: #555555;
}

.generatePayslip-required {
  color: red;
  margin-left: 4px;
}

/* Ensure table is responsive */
@media screen and (max-width: 1200px) {
  .generatePayslip-table {
    font-size: 12px;
  }
  .generatePayslip-table-cell {
    padding: 8px 6px;
    max-width: 100px;
  }
  .generatePayslip-table-header {
    padding: 10px 6px;
    font-size: 11px;
  }
}
.generatePayslip-table-cell .generatePayslip-download-btn {
  background-color: #7FBD2C;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.generatePayslip-table-cell .generatePayslip-download-btn:hover {
  background-color: #b5b9bd;
}

.generatePayslip-table-cell .generatePayslip-download-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.generatePayslip-table-cell .generatePayslip-view-btn {
  background-color: #7FBD2C;
  color: rgb(247, 243, 243);
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.generatePayslip-table-cell .generatePayslip-view-btn:hover {
  background-color: #676868;
}

.generatePayslip-table-cell .generatePayslip-view-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.generatePayslip-details-container {
  max-height: 300px;
  overflow-y: auto;
  margin: 20px 0;
  padding-right: 10px;
}

.generatePayslip-details-table {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #333;
}

.generatePayslip-details-header {
  background-color: #f1f3f5;
  padding: 12px 15px;
  text-align: left;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
}

.generatePayslip-details-cell {
  padding: 12px 15px;
  border-bottom: 1px solid #e9ecef;
  text-align: left;
  vertical-align: top;
}

.generatePayslip-details-cell:first-child {
  font-weight: 500;
  color: #343a40;
  width: 40%;
}

.generatePayslip-details-cell:last-child {
  width: 60%;
}

.generatePayslip-details-title {
  font-size: 18px;
  font-weight: 600;
  color: #212529;
  margin: 0 0 15px 0;
  text-align: center;
}

/* Ensure the modal content is centered and professional */
/* .generatePayslip-popup-box {

  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 20px;
  max-width: 600px;
  width: 90%;
  margin: auto;
} */`, "",{"version":3,"sources":["webpack://./src/components/generate_payslip/generate_payslip.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,8BAA8B;EACzD,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;;qDAKqD;;;AAGrD;;;;;;;;;GASG;;AAEH;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;;EAEX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;AACF;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;;EAEhB,MAAM;EACN,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B,EAAE,uBAAuB;EACxD,gBAAgB;EAChB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,+BAA+B,EAAE,uBAAuB;EACxD,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB,EAAE,oCAAoC;EACxD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,4BAA4B,EAAE,oDAAoD;EAClF,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW,EAAE,2BAA2B;EACxC,QAAQ;EACR,2BAA2B;EAC3B,cAAc,EAAE,gCAAgC;EAChD,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD,uCAAuC;AACvC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc,EAAE,sBAAsB;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,2DAA2D;AAC3D;;EAEE,kBAAkB;AACpB;AACA,4DAA4D;AAC5D,2CAA2C,kBAAkB;EAC3D,gBAAgB;AAClB;AACA,2CAA2C,gBAAgB;EACzD,gBAAgB;AAClB;AACA,2CAA2C,WAAW;EACpD,eAAe;AACjB;AACA,2CAA2C,gBAAgB;EACzD,gBAAgB;AAClB;AACA,2CAA2C,oBAAoB;EAC7D,gBAAgB;AAClB;AACA,2CAA2C,eAAe;EACxD,gBAAgB;AAClB;AACA;2CAC2C,iBAAiB;EAC1D,eAAe;AACjB;AACA;;;4CAG4C,cAAc;EACxD,gBAAgB;AAClB;AACA;;;;;;;;;4CAS4C,eAAe;EACzD,eAAe;AACjB;AACA,4CAA4C,eAAe;EACzD,gBAAgB;AAClB;AACA,4CAA4C,cAAc;EACxD,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,0DAA0D;AAC1D;;;;;;;;;GASG","sourcesContent":[".generatePayslip-container {\n  padding: 20px;\n  max-width: 1100px;\n  margin: 0 auto;\n  border-radius: 8px;\n  max-height: 400px;\n}\n\n.generatePayslip-header {\n  display: flex;\n  justify-content: flex-end; /* Align button to the right */\n  align-items: center;\n  margin-bottom: 20px;\n  padding: 10px 20px;\n  border-radius: 8px;\n}\n.generatePayslip-heading {\n  font-size: 1.75rem;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0;\n}\n\n.generatePayslip-create-btn {\n  padding: 12px 24px;\n  background-color: #7FBD2C;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\n.generatePayslip-create-btn:hover {\n  background-color: #6aa824;\n  transform: translateY(-1px);\n}\n\n.generatePayslip-create-btn:active {\n  transform: translateY(0);\n}\n\n.generatePayslip-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n.generatePayslip-save-only-btn {\n  background-color: #007bff;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.generatePayslip-save-only-btn:hover {\n  background-color: #0056b3;\n}\n\n.generatePayslip-save-only-btn:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n.generatePayslip-error {\n  color: red;\n  font-size: 14px;\n  margin: 10px 0;\n  text-align: center;\n}\n\n.generatePayslip-success {\n  color: green;\n  font-size: 14px;\n  margin: 10px 0;\n  text-align: center;\n}\n.generatePayslip-required {\n  color: red;\n  margin-left: 4px;\n}\n.generatePayslip-table-container {\n  max-height: 600px;\n  overflow-y: auto;\n  margin-top: 20px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n/* .generatePayslip-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  table-layout: auto;\n  border: 1px solid #e0e0e0; /* Add border to table */\n \n\n/* .generatePayslip-table-header {\n  position: sticky;\n  top: 0;\n  background-color: #f4f4f4;\n  padding: 12px;\n  text-align: left;\n  border-bottom: 2px solid #ddd;\n  font-weight: bold;\n  z-index: 1;\n} */\n\n.generatePayslip-table td {\n  padding: 10px;\n  border-bottom: 1px solid #ddd;\n}\n\n.generatePayslip-table tr:hover {\n  background-color: #f9f9f9;\n}\n\n.generatePayslip-edit-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  color: #007bff;\n}\n\n.generatePayslip-edit-btn:hover {\n  color: #0056b3;\n}\n.generatePayslip-form-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n.generatePayslip-popup-box {\n  margin-top:70px;\n  position: relative;\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 20px;\n  width: 900px;\n  max-width: 90%;\n  max-height: 70vh;\n  overflow-y: auto;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e0e0e0;\n}\n\n.generatePayslip-popup-title {\n  background-color: #00468C;\n  color: white;\n  padding: 15px;\n  margin: -20px -20px 20px -20px;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  font-size: 20px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.generatePayslip-popup-close-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background-color: #ffffff;\n  color: #00468C;\n  border: 2px solid #00468C;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease, color 0.2s ease, transform 0.1s ease;\n}\n\n.generatePayslip-popup-close-btn:hover {\n  background-color: #00468C;\n  color: white;\n  transform: scale(1.1);\n}\n\n.generatePayslip-popup-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.generatePayslip-form-row {\n  display: flex;\n  gap: 20px;\n  flex-wrap: nowrap;\n}\n\n.generatePayslip-form-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n  min-width: 0;\n}\n\n.generatePayslip-form-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.generatePayslip-popup-input {\n  width: 100%;\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.generatePayslip-popup-input:focus {\n  border-color: #00468C;\n  outline: none;\n}\n\n.generatePayslip-form-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.generatePayslip-cancel-btn,\n.generatePayslip-save-btn,\n.generatePayslip-preview-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n}\n\n.generatePayslip-cancel-btn {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.generatePayslip-cancel-btn:hover {\n  background-color: #d0d0d0;\n}\n\n.generatePayslip-save-btn,\n.generatePayslip-preview-btn {\n  background-color: #00468C;\n  color: white;\n}\n\n.generatePayslip-save-btn:hover,\n.generatePayslip-preview-btn:hover {\n  background-color: #003a6e;\n}\n\n.generatePayslip-preview {\n  font-size: 14px;\n  color: #333;\n}\n\n.generatePayslip-preview-header {\n  text-align: left;\n  margin-bottom: 20px;\n}\n\n.generatePayslip-preview-header h4 {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 5px;\n}\n\n.generatePayslip-preview-header p {\n  font-size: 12px;\n  margin: 2px 0;\n}\n\n.generatePayslip-preview-header h5 {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 10px 0 5px;\n}\n\n.generatePayslip-preview-table {\n  width: 100%;\n\n  border-collapse: collapse;\n  margin-bottom: 15px;\n}\n\n.generatePayslip-preview-table th,\n.generatePayslip-preview-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n  font-size: 12px;\n}\n\n.generatePayslip-preview-table th {\n  background-color: #00468C;\n  color: white;\n  font-weight: 600;\n}\n\n.generatePayslip-preview-table.earnings-deductions th,\n.generatePayslip-preview-table.earnings-deductions td {\n  width: 25%;\n}\n\n.generatePayslip-preview p {\n  font-size: 12px;\n  margin: 5px 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .generatePayslip-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .generatePayslip-create-btn {\n    width: 100%;\n    text-align: center;\n  }\n\n  .generatePayslip-popup-box {\n    width: 90%;\n    padding: 15px;\n  }\n\n  .generatePayslip-popup-title {\n    font-size: 18px;\n    padding: 12px;\n  }\n\n  .generatePayslip-form-row {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .generatePayslip-form-group {\n    width: 100%;\n  }\n\n  .generatePayslip-preview-table.earnings-deductions th,\n  .generatePayslip-preview-table.earnings-deductions td {\n    width: auto;\n  }\n}\n.generatePayslip-table-container {\n  max-height: 400px;\n  overflow-y: auto;\n  overflow-x: auto;\n  margin-top: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n}\n\n.generatePayslip-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  table-layout: auto;\n}\n\n.generatePayslip-table-header {\n  position: sticky;\n  \n  top: 0;\n  background-color: #f8f9fa;\n  padding: 12px 8px;\n  text-align: left;\n  border-bottom: 2px solid #dee2e6;\n  border-right: 1px solid #dee2e6; /* Add vertical lines */\n  font-weight: 800;\n  color: #333;\n  /* text-transform: uppercase; */\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.generatePayslip-table-cell {\n  padding: 10px 8px;\n  border-bottom: 1px solid #e9ecef;\n  border-right: 1px solid #e9ecef; /* Add vertical lines */\n  text-align: left;\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n/* Search bar container */\n.generatePayslip-search-container {\n  display: flex;\n  align-items: center;\n  position: relative; /* For positioning the search icon */\n  max-width: 270px;\n  margin-left:-20px;\n}\n\n/* Search input */\n.generatePayslip-search-input {\n  padding: 10px 36px 10px 10px; /* Add padding-right for icon, reduce padding-left */\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease;\n}\n\n.generatePayslip-search-input:focus {\n  border-color: #00468C;\n  outline: none;\n}\n\n/* Search icon */\n.generatePayslip-search-icon {\n  position: absolute;\n  right: 10px; /* Move icon to the right */\n  top: 50%;\n  transform: translateY(-50%);\n  color: #8f8c8c; /* Black color for search icon */\n  font-size: 16px;\n}\n\n/* Ensure header layout */\n.generatePayslip-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding: 10px 20px;\n  border-radius: 8px;\n}\n\n/* Rest of your existing CSS remains unchanged */\n/* Edit button with boxed pencil icon */\n.generatePayslip-edit-btn {\n  background: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  color: #000000; /* Black pencil icon */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n}\n\n.generatePayslip-edit-btn:hover {\n  background: #e9ecef;\n  color: #555555;\n}\n/* Last column without right border to avoid double lines */\n.generatePayslip-table-cell:last-child,\n.generatePayslip-table-header:last-child {\n  border-right: none;\n}\n/* Specific column widths to minimize horizontal scrolling */\n.generatePayslip-table-cell:nth-child(1) { /* Employee Name */\n  max-width: 120px;\n}\n.generatePayslip-table-cell:nth-child(2) { /* Employee ID */\n  max-width: 100px;\n}\n.generatePayslip-table-cell:nth-child(3) { /* Gender */\n  max-width: 80px;\n}\n.generatePayslip-table-cell:nth-child(4) { /* Designation */\n  max-width: 100px;\n}\n.generatePayslip-table-cell:nth-child(5) { /* Date of Joining */\n  max-width: 100px;\n}\n.generatePayslip-table-cell:nth-child(6) { /* Account No */\n  max-width: 100px;\n}\n.generatePayslip-table-cell:nth-child(7), /* Working Days */\n.generatePayslip-table-cell:nth-child(8) { /* Leaves Taken */\n  max-width: 80px;\n}\n.generatePayslip-table-cell:nth-child(9), /* UIN No */\n.generatePayslip-table-cell:nth-child(10), /* PAN Number */\n.generatePayslip-table-cell:nth-child(11), /* ESI Number */\n.generatePayslip-table-cell:nth-child(12) { /* PF Number */\n  max-width: 100px;\n}\n.generatePayslip-table-cell:nth-child(13), /* Basic */\n.generatePayslip-table-cell:nth-child(14), /* HRA */\n.generatePayslip-table-cell:nth-child(15), /* Other Allowance */\n.generatePayslip-table-cell:nth-child(16), /* PF */\n.generatePayslip-table-cell:nth-child(17), /* ESI/Insurance */\n.generatePayslip-table-cell:nth-child(18), /* Professional Tax */\n.generatePayslip-table-cell:nth-child(19), /* TDS */\n.generatePayslip-table-cell:nth-child(20), /* Gross Earnings */\n.generatePayslip-table-cell:nth-child(21), /* Total Deductions */\n.generatePayslip-table-cell:nth-child(22) { /* Net Salary */\n  max-width: 90px;\n}\n.generatePayslip-table-cell:nth-child(23) { /* Created At */\n  max-width: 120px;\n}\n.generatePayslip-table-cell:nth-child(24) { /* Edit Data */\n  max-width: 60px;\n  text-align: center;\n}\n\n.generatePayslip-table tr:hover {\n  background-color: #f1f3f5;\n}\n\n.generatePayslip-edit-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  color: #000000; /* Black pencil icon */\n}\n\n.generatePayslip-edit-btn:hover {\n  color: #555555;\n}\n\n.generatePayslip-required {\n  color: red;\n  margin-left: 4px;\n}\n\n/* Ensure table is responsive */\n@media screen and (max-width: 1200px) {\n  .generatePayslip-table {\n    font-size: 12px;\n  }\n  .generatePayslip-table-cell {\n    padding: 8px 6px;\n    max-width: 100px;\n  }\n  .generatePayslip-table-header {\n    padding: 10px 6px;\n    font-size: 11px;\n  }\n}\n.generatePayslip-table-cell .generatePayslip-download-btn {\n  background-color: #7FBD2C;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.generatePayslip-table-cell .generatePayslip-download-btn:hover {\n  background-color: #b5b9bd;\n}\n\n.generatePayslip-table-cell .generatePayslip-download-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n.generatePayslip-table-cell .generatePayslip-view-btn {\n  background-color: #7FBD2C;\n  color: rgb(247, 243, 243);\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.generatePayslip-table-cell .generatePayslip-view-btn:hover {\n  background-color: #676868;\n}\n\n.generatePayslip-table-cell .generatePayslip-view-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.generatePayslip-details-container {\n  max-height: 300px;\n  overflow-y: auto;\n  margin: 20px 0;\n  padding-right: 10px;\n}\n\n.generatePayslip-details-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n  color: #333;\n}\n\n.generatePayslip-details-header {\n  background-color: #f1f3f5;\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 2px solid #dee2e6;\n  font-weight: 600;\n  color: #495057;\n}\n\n.generatePayslip-details-cell {\n  padding: 12px 15px;\n  border-bottom: 1px solid #e9ecef;\n  text-align: left;\n  vertical-align: top;\n}\n\n.generatePayslip-details-cell:first-child {\n  font-weight: 500;\n  color: #343a40;\n  width: 40%;\n}\n\n.generatePayslip-details-cell:last-child {\n  width: 60%;\n}\n\n.generatePayslip-details-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #212529;\n  margin: 0 0 15px 0;\n  text-align: center;\n}\n\n/* Ensure the modal content is centered and professional */\n/* .generatePayslip-popup-box {\n\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 20px;\n  max-width: 600px;\n  width: 90%;\n  margin: auto;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
